module.exports = __webpack_public_path__ + "img/evacuate.f05d7e5b.jpg";